import React, {useEffect, useState} from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import {ExchangeMapElementType, ExchangeMapType, ExchangeSearchParamType} from "../../../../exchange/detail/interface";
import {exchangeMapInit, exchangeSearchParamInit} from "../../../../exchange/detail/state";
import {useReadExchangeRate} from "../../../../exchange/detail/hooks/useReadExchangeRate";
import {useModal} from "../../../../../../hooks";
import EmptyTableRow from "../../../../../common/EmptyTableRow";
import moment from "moment/moment";
import useGoToNavigation from "../../../../../../util/useGotoNavigation";
import DisplayNumber from "../../../../../../components/common/number/DisplayNumber";

interface DropdownItemType {
    id: string,
    text: string
}

const dropdownItems: DropdownItemType[] = [
    {id: "USD", text: "미국"},
    {id: "SGD", text: "싱가포르"},
    {id: "INR", text: "인도"},
    {id: "AUD", text: "호주"},
    {id: "CNY", text: "중국"},
    {id: "MYR", text: "말레이시아"},
    {id: "HKD", text: "홍콩"},
];

export const ExRateInfo = () => {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation()

    const [tab, setTab] = useState<number>(1);
    const [currentItem, setCurrentItem] = useState<DropdownItemType>({id: "USD", text: "미국"})
    const [searchParam, setSearchParam] = useState<ExchangeSearchParamType>(exchangeSearchParamInit)
    const [exchange, setExchange] = useState<ExchangeMapType | string>(exchangeMapInit)

    const {mutateAsync: mutateAsyncReadExchangeRate} = useReadExchangeRate()

    useEffect(() => {
        mutateAsyncReadExchangeRate(searchParam).then(res => {
            if (res?.data?.code !== "0000") {
                setExchange(res.data.msg)
            } else {
                setExchange(res.data.result ?? exchangeMapInit)
            }
        }).catch(e => {
            if (e?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: e?.response?.data?.msg,
                    type: "alert",
                });
            }
        })
    }, [searchParam]);


    useEffect(() => {
        if (tab === 1) {
            setSearchParam(exchangeSearchParamInit)
        } else {
            setSearchParam({
                ...exchangeSearchParamInit,
                keywordType2Name: "전월 평균",
                keywordType2: "202",
                startAt: moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"),
                endAt: moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD")
            })
        }
    }, [tab])

    const exchangeRow = (data: ExchangeMapElementType) =>
        <tr>
            <td>{`${currentItem.id}(${currentItem.text})`}</td>
            <td className="text-end"><DisplayNumber value={data.cashBuyRate}/></td>
            <td className="text-end"><DisplayNumber value={data.cashSellRate}/></td>
            <td className="text-end"><DisplayNumber value={data.remittanceSendRate}/></td>
            <td className="text-end"><DisplayNumber value={data.remittanceReceiveRate}/></td>
            <td className="text-end"><DisplayNumber value={data.baseExchangeRate}/></td>
        </tr>

    const clickTable = () => goToNavigation("main/exchange", {}, false)

    return (
        <>
            <div className="content_wrap h-221px">
                <div className="fiter_top">
                    <h3 className="filter_heading">환율정보</h3>
                    <div className="filter_toolbar"></div>
                </div>

                <div className="mybtns_group mt-5px mb-10px">
                    <div className="btn-group" role="group" aria-label="">
                        <button type="button" className={tab === 1 ? "btn btn-light active" : "btn btn-light"}
                                onClick={() => setTab(1)}>당일환율
                        </button>
                        <button type="button" className={tab === 2 ? "btn btn-light active" : "btn btn-light"}
                                onClick={() => setTab(2)}>전월평균
                        </button>
                    </div>
                    <div className="mybtns_group_toolbar align-items-center">
                        <span className="text-danger me-2">* 최초고시 기준</span>
                        <Dropdown className="d-inline-block dd_dashboard">
                            <Dropdown.Toggle variant="outline-secondary"
                                             title={`${currentItem.id}(${currentItem.text})`}>
                                {`${currentItem.id}(${currentItem.text})`}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100">
                                {dropdownItems.map((el: DropdownItemType, index: number) => (
                                    <Dropdown.Item key={index} onClick={() => setCurrentItem(el)}>
                                        {`${el.id}(${el.text})`}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>

                <table className="table table-bordered my_table mb-0 clickable" onClick={clickTable}>
                    <thead>
                    <tr>
                        <th style={{width: "23%"}} rowSpan={2}>통화</th>
                        <th style={{width: "27.1%"}} colSpan={2}>환율</th>
                        <th style={{width: "27.1%"}} colSpan={2}>송금</th>
                        <th rowSpan={2}>매매<br/>기준율</th>
                    </tr>
                    <tr>
                        <th style={{width: "13.53%"}}>사실때</th>
                        <th>파실때</th>
                        <th style={{width: "13.53%"}}>보낼때</th>
                        <th>받을때</th>
                    </tr>
                    </thead>
                    <tbody>
                    {typeof exchange !== "string"
                        ? <>
                            {currentItem.id === "AUD" && exchangeRow(exchange.searchExchangeResMap.ANZ)}
                            {currentItem.id === "CNY" && exchangeRow(exchange.searchExchangeResMap.CHN)}
                            {currentItem.id === "HKD" && exchangeRow(exchange.searchExchangeResMap.HK)}
                            {currentItem.id === "INR" && exchangeRow(exchange.searchExchangeResMap.IND)}
                            {currentItem.id === "MYR" && exchangeRow(exchange.searchExchangeResMap.MY)}
                            {currentItem.id === "SGD" && exchangeRow(exchange.searchExchangeResMap.SEA)}
                            {currentItem.id === "USD" && exchangeRow(exchange.searchExchangeResMap.USD)}
                        </>
                        : <EmptyTableRow colSpan={6} msg={exchange}/>}
                    </tbody>
                </table>
            </div>
        </>
    )
}